import { useInstance } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { useReceive } from '../../hooks/useReceive';
export function useStatus() {
  var instance = useInstance();
  var status = useState('active');
  function setStatus() {
    var _instance$get = instance.get(),
      _status = _instance$get.status,
      percent = _instance$get.percent;
    if (Number(percent) === 100 && _status !== 'error') {
      status.set('success');
    } else {
      status.set(_status);
    }
  }
  useReceive(['status', 'percent'], setStatus);
  return status;
}